import React from 'react';
import { steps } from '../data/offer';
export function HowItWorks() {
  return <section aria-labelledby="pasos-titulo" className="w-full bg-cream-50" data-id="element-141" data-mp="7slp8wqvfxqj">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-20 lg:py-28" data-id="element-142" data-mp="7qsizik67fj2">
        <div className="max-w-2xl" data-id="element-143" data-mp="3q0b32kfgsvar">
          <h2 id="pasos-titulo" className="font-display text-2xl font-extrabold leading-tight tracking-tight text-forest-900 sm:text-4xl" data-id="element-144" data-mp="3tztodhb778e4">
            ¿Cómo funciona el desafío?
          </h2>
          <p className="mt-3 text-[15px] text-forest-800/75 sm:mt-4 sm:text-lg" data-id="element-145" data-mp="qibhpd75w7fa">
            En solo 3 pasos simples.
          </p>
        </div>

        <ol className="mt-7 sm:mt-12 lg:mt-16" data-id="element-146" data-mp="cpvjqqt4azl8">
          {steps.map((step, index) => <li key={step.number} className="relative flex gap-4 pb-6 last:pb-0 sm:gap-8 sm:pb-10" data-id="element-147" data-mp="grgv27q075tb" data-mpi={index}>
              {index < steps.length - 1 && <span aria-hidden="true" className="absolute left-[19px] top-11 h-[calc(100%-2.75rem)] w-px bg-cream-300 sm:left-[27px] sm:top-14 sm:h-[calc(100%-3.5rem)]" data-id="element-148" data-mp="19adzirvjhtr4" />}
              <span className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-forest-800 font-display text-base font-extrabold text-cream-50 sm:h-14 sm:w-14 sm:text-xl" data-id="element-149" data-mp="2moeby785stes">
                {step.number}
              </span>
              <div className="pt-1 sm:pt-2.5" data-id="element-150" data-mp="3abme4gaajmcl">
                <h3 className="font-display text-base font-bold leading-snug text-forest-900 sm:text-2xl" data-id="element-151" data-mp="3aachzwn00o8l">
                  {step.title}
                </h3>
                <div className="mt-2 max-w-2xl space-y-2 text-sm leading-relaxed text-forest-800/85 sm:mt-3 sm:space-y-3 sm:text-[15px]" data-id="element-152" data-mp="3kalhbjcaeps7">
                  {step.paragraphs.map(paragraph => <p key={paragraph} data-id="element-153" data-mp="1pviw3xu9ttv3">{paragraph}</p>)}
                </div>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}